import { DEMO_CONNECTION_INDEX, getPortalSdk } from 'portal-sdk';
import { useQuery } from 'react-query';
import { isOnPremise, usePortalConnections } from 'vet-bones/utils/portal';

import { QUERY_STALE_TIME } from 'src/constants/limits';
import {
  Connection,
  coercePortalConnection,
} from 'src/store/connections/types';

export const usePortalConnectionByIndex = (
  index = 0,
  fallbackToFirstConnection = true
) => {
  const portalConnections = usePortalConnections();
  const firstPortalConnection = portalConnections.data?.[0] || null;
  return useQuery<Connection | null>(
    ['usePortalConnectionByIndex', index, firstPortalConnection?.id],
    async () => {
      // Don't get the demo connection for Launch Pad
      if (isOnPremise() && index === DEMO_CONNECTION_INDEX) {
        return null;
      }

      const sdk = getPortalSdk();
      if (!sdk) {
        return null;
      }

      let connection = await sdk.getConnectionByIndex(index);
      if (!connection) {
        if (!fallbackToFirstConnection) {
          return null;
        }
        // Take the first connection if we couldn't gather url info.
        //
        // We do this because components like NewVirtualGraphTile
        // rely on a connection to be setup before they show the ConnectionMenu selector.
        //
        // Another reason we do this is for cypress, since its url doesn't contain the path: /u/0/designer/
        connection = firstPortalConnection;
        if (!window.Cypress) {
          console.warn(
            'Failed to get connection from URL, returning the first connection instead'
          );
        }
      }

      return connection ? coercePortalConnection(connection) : null;
    },
    { refetchOnWindowFocus: false, staleTime: QUERY_STALE_TIME }
  );
};

declare global {
  interface Window {
    Cypress?: unknown;
  }
}
